import bulkSetChildrenPresence from './bulk-set-children-presence';
import deleteElement from './delete-element';
import duplicateElement from './duplicate-element';
import insertElement from './insert-element';
import shiftElement from './shift-element';
import replaceElement from './replace-element';
import removeElementAttribute from './remove-element-attribute';
import setElementAttribute from './set-element-attribute';
import setInlineElementStyle from './set-inline-element-style';
import setChildrenPresence from './set-children-presence';
import synchronizeElement from './synchronize-element';
import updateAtomicCss from './update-atomic-css';

export default {
  bulkSetChildrenPresence,
  deleteElement,
  duplicateElement,
  insertElement,
  shiftElement,
  replaceElement,
  removeElementAttribute,
  setElementAttribute,
  setInlineElementStyle,
  setChildrenPresence,
  synchronizeElement,
  updateAtomicCss,
};
